import { useEffect, useState } from 'react';
import Collapsible from 'react-collapsible';
import { images } from '../../../Constants/ImageUrls';
import {
  applyGesture,
  handleWidgetAccToUser,
} from '../../../Utils/productPageUtils';
import { categoryNameCollapsed, categoryNameExpanded } from './common';
import {
  ExpertAvatar,
  ExpertBody,
  ExpertSubheading,
  ExpertWidget,
  SectionContainer,
  SectionTitle,
} from './styled';

export default function ExpertContent(props) {
  const {
    itemData,
    clickedHandler,
    productCategory,
    index,
    Ido,
    clinic,
    WidgetContainImage,
    showNewLandingPageUI,
  } = props;
  // const openWidget = useRef();
  // useEffect(() => {
  //     openWidget.current = showCollapsedView();
  // }, []);
  const widgetIsOpened = Ido || clinic || !itemData.default_collapsed;
  const [openWidget, setOpenWidget] = useState(widgetIsOpened);
  const [plusMinusDropDown, setPlusMinusDropDown] = useState(
    openWidget ? images.minusSvg : images.plusBlack,
  );
  const [gestureEffect, setGestureEffect] = useState('');
  const [widgetHandle, setWidgetHandle] = useState({
    widgetImage: '',
    widgetClass: '',
  });
  const handleWidgetState = (categoryNameState, widgetOpen, imageType) => {
    applyGesture(setGestureEffect);
    clickedHandler(categoryNameState, index, itemData.title);
    setOpenWidget(widgetOpen);
    setPlusMinusDropDown(imageType);
  };
  // useEffect(() => {
  //     setOpenWidget(showCollapsedView(index, WidgetContainImage));
  // }, [itemData])
  useEffect(() => {
    const state = widgetIsOpened;
    handleWidgetState(
      state ? categoryNameExpanded : categoryNameCollapsed,
      state,
      state ? images.minusSvg : images.plusBlack,
    );
  }, [itemData.default_collapsed]);
  useEffect(() => {
    handleWidgetAccToUser(plusMinusDropDown, setWidgetHandle);
  }, [plusMinusDropDown]);
  return (
    <SectionContainer
      showNewLandingPageUI={showNewLandingPageUI}
      productcategory={productCategory}
    >
      <Collapsible
        trigger={
          <SectionTitle className={` ${gestureEffect} aplusTitleSize`}>
            {itemData.title}
            <img
              loading="lazy"
              src={widgetHandle.widgetImage}
              className={widgetHandle.widgetClass}
              alt="arrow"
            />
          </SectionTitle>
        }
        key={index}
        onOpening={() => {
          handleWidgetState(categoryNameExpanded, true, images.minusSvg);
        }}
        onClosing={() => {
          handleWidgetState(categoryNameCollapsed, false, images.plus);
        }}
        // onOpening={() =>
        //     clickedHandler(categoryNameExpanded, index, itemData.title)
        // }
        // onClosing={() =>
        //     clickedHandler(categoryNameCollapsed, index, itemData.title)
        // }
        open={openWidget}
        triggerOpenedClassName="triggerClassAplus"
        transitionTime={200}
      >
        {itemData?.widgetContent?.map((item, index) => (
          <ExpertWidget key={`expertReview${index}`}>
            <ExpertSubheading>
              <ExpertAvatar>
                <img
                  loading="lazy"
                  className="coverimage"
                  src={'https://mylofamily.com/v2/static/images/opencircle.svg'}
                  alt={
                    item?.imageAltName
                      ? item?.imageAltName
                      : `${item?.fallbackAltName}`
                  }
                />
                <img
                  loading="lazy"
                  className="expertAvatar"
                  src={item?.url + '?tr=w-80'}
                  srcSet={`${item?.url}?tr=w-80 2x, ${item?.url}?tr=w-40 1x`}
                  alt={
                    item?.imageAltName
                      ? item?.imageAltName
                      : `${item?.fallbackAltName} expert avatar`
                  }
                />
              </ExpertAvatar>

              <div className="title">
                {item.heading}
                <p className="specialization">{item.specialization}</p>
              </div>
            </ExpertSubheading>
            <ExpertBody>&quot;{item?.body}&quot;</ExpertBody>
          </ExpertWidget>
        ))}
      </Collapsible>
    </SectionContainer>
  );
}
